import React, { } from 'react'
import { Redirect } from 'react-router-dom'

import cars from './../data/cars.json'
import { createPrefixOfUrl } from './../common'

const Home = () => {
    return (
        <>
            {cars.length > 1 ? (
                <Redirect to={`${createPrefixOfUrl()}/showroom`} />
            ) : (
                <Redirect to={`${createPrefixOfUrl()}/${cars[0].id}/exterior`} />
            )}
        </>
    )
}

export default Home